import {
  BsFacebook,
  BsGithub,
  BsGlobe,
  BsInstagram,
  BsLinkedin,
  BsStackOverflow,
  BsTwitterX,
} from 'react-icons/bs';
import { Greenhouse } from '@/assets/icons/colored';
import { Lever } from '@/assets/icons/colored';
import { Ashby } from '@/assets/icons/colored';
import { REGEX_PATTERNS } from '@/constants/regex';

/**
 * Candidate social/source link display + validation config.
 *
 * Relocated here from `src/pages/contacts/details-revamp/info/fields/helpers`
 * so cross-feature consumers (the candidate-job-drawer components) stop
 * importing into the contacts page layer. The original module re-exports this
 * for within-feature callers.
 */
export const candidateLinksConfig = [
  {
    id: 'linkedin_url',
    icon: BsLinkedin,
    color: ' #2D64BC',
    label: 'Linkedin',
    regex: REGEX_PATTERNS.linkedin,
  },
  {
    id: 'twitter_url',
    icon: BsTwitterX,
    label: 'Twitter',
    regex: /^(https?:\/\/)?(www\.)?(twitter\.com|x\.com)\/[a-zA-Z0-9_]+(\/)?$/,
  },
  {
    id: 'github_url',
    icon: BsGithub,
    label: 'Github',
    regex: /^(https?:\/\/)?(www\.)?github\.com\/[a-zA-Z0-9_-]+(\/)?$/,
  },
  {
    id: 'stackoverflow_url',
    icon: BsStackOverflow,
    label: 'Stackoverflow',
    regex:
      /^(https?:\/\/)?(www\.)?stackoverflow\.com\/users\/[0-9]+\/[a-zA-Z0-9_-]+(\/)?$/,
    color: '#e7700d',
  },
  {
    id: 'facebook_url',
    icon: BsFacebook,
    label: 'Facebook',
    regex: /^(https?:\/\/)?(www\.)?facebook\.com\/[a-zA-Z0-9.]+(\/)?$/,
    color: '#1877F2',
  },
  {
    id: 'instagram_url',
    icon: BsInstagram,
    label: 'Instagram',
    regex: /^(https?:\/\/)?(www\.)?instagram\.com\/[a-zA-Z0-9._]+(\/)?$/,
    color: '#dd2a7b',
  },
  {
    id: 'website_url',
    icon: BsGlobe,
    label: 'Website',
    regex:
      /https?:\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?/, // eslint-disable-line no-useless-escape
  },
  { id: 'ashby_url', icon: Ashby, skipForForm: true },
  { id: 'lever_url', icon: Lever, skipForForm: true },
  { id: 'greenhouse_url', icon: Greenhouse, skipForForm: true },
];
